import { Box, Grid, Typography, useTheme } from '@mui/material'
import React from 'react'
import { Status } from '../type'

const dummy = [
    {
        label: 'Total AUM',
        value: 500,
        color: 1
    },
    {
        label: "Cast Available",
        value: 100,
        color: 2,
    },
    {
        label: 'Accounts',
        value: 400,
        color: 3
    }
]

export default function OnBoardingStatus() {
    const { typography, palette } = useTheme()

    return (
        <Box sx={{ padding: '25px 30px 25px 30px', gap: '16px', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <Typography variant='h2'>AUM Distribution</Typography>
                <Typography variant='body_500' color={palette.grey[700]}>Last 4 Months</Typography>
            </Box>
            <Grid
                container
                columnGap={1}
            >
                {dummy.map((ele, index) => (
                    <InfoCart {...ele} key={index} />
                ))}
            </Grid>
        </Box>
    )
}




const InfoCart = (item: Status) => {
    const { color, label, value } = item
    const { typography, palette } = useTheme()
    return (
        <Grid item
            lg={3.8}
            md={3.8}
            sm={12}
            xs={12}>

            <Box sx={{
                width: '100%',
                padding: '25px 0px 25px 18px',
                background: color === 1 ? palette.customColors.aumRedLight : color === 2 ? palette.customColors.aumOrangeLight : palette.customColors.aumBlueLight,
                borderRadius: '20px',
            }}>
                <Typography variant='body_500' >{label}</Typography>
                <Typography variant='body_700'
                    color={color === 1 ? palette.customColors.aumRed : color === 2 ? palette.customColors.aumOrange : palette.customColors.aumBlue}>
                    {value}
                </Typography>

            </Box>
        </Grid>
    )
}